export const isChecked = (value: any, selectedVal: any): boolean => value.toString() === selectedVal;
